// Auto-generated fallback data from the latest sheet response
export const INITIAL_MEMBERS = [
  {
    "id": "101",
    "name": "Sanat Sikhar Sinha",
    "designation": "President",
    "team": "Secretariat",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "102",
    "name": "Kumar Bibhudatta",
    "designation": "Vice President",
    "team": "Secretariat",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "103",
    "name": "Eshan Mohanty",
    "designation": "Manager",
    "team": "Secretariat",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "104",
    "name": "Abhinav Singh",
    "designation": "Treasurer",
    "team": "Secretariat",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "105",
    "name": "Subham Panda",
    "designation": "Lead",
    "team": "Event Management Team",
    "email": "subhampanda1000@gmail.com",
    "phone": "8280651536",
    "linkedin": "https://www.linkedin.com/in/subham-panda-764a69293?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "subham_panda04",
    "branch": "CSE",
    "year": "4th year",
    "regNo": "2341016100",
    "dob": "10/10/2004",
    "photo": "https://lh3.googleusercontent.com/d/1e0lZ3PazWyGfIG3ZjjvPPwLoPzZLNvtA"
  },
  {
    "id": "106",
    "name": "Parminder Singh",
    "designation": "Core member",
    "team": "Event Management Team",
    "email": "singh.sanjam18@gmail.com",
    "phone": "6203023719",
    "linkedin": "https://www.linkedin.com/in/parminder-singh-a22710268?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "_singh.18",
    "branch": "Cse",
    "year": "3rd year",
    "regNo": "24E119E11",
    "dob": "7/20/2026",
    "photo": "https://lh3.googleusercontent.com/d/1rwA7IFV-xGN_HQL1OuWtWNAEZ1fpbRSt"
  },
  {
    "id": "107",
    "name": "Saranya Dash",
    "designation": "Core member",
    "team": "Content, Design Team",
    "email": "dashsaranya.soa@gmail.com",
    "phone": "9124648155",
    "linkedin": "https://www.linkedin.com/in/saranya-dash-aa491a375?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "https://www.instagram.com/just_a_birkin?stkn=MWdmdDRlYXFidHNmOQ==",
    "branch": "Btech Cse core",
    "year": "2nd year",
    "regNo": "25E104B47",
    "dob": "8/26/2007",
    "photo": "https://lh3.googleusercontent.com/d/1yFnax_1t8ozqEJVSM2cWifWI_37F9gGL"
  },
  {
    "id": "108",
    "name": "Neelesh Kumar Behera",
    "designation": "Core member",
    "team": "Media Team",
    "email": "neeleshbehera81@gmail.com",
    "phone": "8984555935",
    "linkedin": "https://www.linkedin.com/in/neelesh-kumar-behera-2183433b3?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
    "instagram": "https://www.instagram.com/_.neelesh._.nkb._?stkn=MTY2ejloMjI1ajJ1OA%3D%3D&utm_source=qr",
    "branch": "B.tech CSE",
    "year": "3rd year",
    "regNo": "24E102A82",
    "dob": "8/8/2006",
    "photo": "https://lh3.googleusercontent.com/d/1nG_2XYFI0T4cs2MpRXSgqoLlQbxhOqSu"
  },
  {
    "id": "109",
    "name": "Rohit Mukhi",
    "designation": "Core member",
    "team": "Content Team",
    "email": "rohitmukhi52@gmail.com",
    "phone": "8580371372",
    "linkedin": "https://www.linkedin.com/in/rohit-mukhi-009a14263?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "rohit__mukhi",
    "branch": "CSE",
    "year": "4th year",
    "regNo": "2341013419",
    "dob": "6/30/2003",
    "photo": "https://lh3.googleusercontent.com/d/1ZX_DLTMVpIBIATmwhMRDXeWEDVp8nXHX"
  },
  {
    "id": "110",
    "name": "Kalyan Jyoti Mishra",
    "designation": "Core member",
    "team": "Event Management Team",
    "email": "kalyanjyotimishra@gmail.com",
    "phone": "7682953323",
    "linkedin": "https://www.linkedin.com/in/kalyan-jyoti-mishra",
    "instagram": "https://www.instagram.com/onlyonekalyan?stkn=MWZtcWw2ZHZ1NmNzOQ==",
    "branch": "Data science",
    "year": "2nd year",
    "regNo": "25E113B78",
    "dob": "7/22/2007",
    "photo": "https://lh3.googleusercontent.com/d/1HQ_eLIrAmMmc9D9h_gKi1LuyPAZagYJT"
  },
  {
    "id": "111",
    "name": "Spandan Pattanaik",
    "designation": "Core member",
    "team": "Public Relation Team",
    "email": "spandanpattanaik2007@gmail.com",
    "phone": "7978667994",
    "linkedin": "https://www.linkedin.com/in/spandan-pattanaik-032b201b4?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "https://www.instagram.com/spandan__pattanaik?stkn=eHc0OGJwdTRqNHhy",
    "branch": "CSE CORE",
    "year": "3rd year",
    "regNo": "24E116C39",
    "dob": "2/5/2007",
    "photo": "https://lh3.googleusercontent.com/d/1V4Qlsh5UVPJtDefIdj2vqF_7dNwzR_rh"
  },
  {
    "id": "112",
    "name": "Utkarsh Sinha",
    "designation": "Core member",
    "team": "Technical Team",
    "email": "sinhau65@gmail.com",
    "phone": "9142195378",
    "linkedin": "www.linkedin.com/in/utkarshhhsinha",
    "instagram": "https://www.instagram.com/my.utkarshhh/",
    "branch": "Btech Cse (AI/ML)",
    "year": "3rd year",
    "regNo": "24E119E33",
    "dob": "6/5/2005",
    "photo": "https://lh3.googleusercontent.com/d/1EYmqJMbVLcKnqOejLGalxbA5i9AUrYA2"
  },
  {
    "id": "113",
    "name": "Rajeev Pramanik",
    "designation": "Core member",
    "team": "Technical Team",
    "email": "imrajeev20@gmail.com",
    "phone": "8789850340",
    "linkedin": "https://www.linkedin.com/in/rajeev-pramanik-248105331?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "rajeev.pramanik18",
    "branch": "CSE(AIML)",
    "year": "2nd year",
    "regNo": "25E116D72",
    "dob": "8/20/2004",
    "photo": "https://lh3.googleusercontent.com/d/1vOCvaX9JRKrcn6TRaVa8_mkU8AynFaOu"
  },
  {
    "id": "114",
    "name": "Sujay Jagat",
    "designation": "Lead",
    "team": "Technical Team",
    "email": "sjagat222@gmail.com",
    "phone": "7004577714",
    "linkedin": "https://www.linkedin.com/in/sujay-jagat-7ab37b32a?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "https://www.instagram.com/sujay.jagat?stkn=MXM4N2RxOWpzajNpeA==",
    "branch": "CSE CORE",
    "year": "3rd year",
    "regNo": "24E110A82",
    "dob": "11/24/2005",
    "photo": "https://lh3.googleusercontent.com/d/1pAXkPS5RkZqRDJ2aYk5KLIANCx5Mot-J"
  },
  {
    "id": "115",
    "name": "D.Amarnath Patro",
    "designation": "Core member",
    "team": "Public Relation Team",
    "email": "amarpatro25@gmail.com",
    "phone": "9861422119",
    "linkedin": "https://www.linkedin.com/in/amarnathpatro/",
    "instagram": "https://www.instagram.com/amar_the_one?stkn=MXFob3R4dHY5aXVsZQ==",
    "branch": "CSE(CYSEC)",
    "year": "3rd year",
    "regNo": "24E116C27",
    "dob": "8/31/2006",
    "photo": "https://lh3.googleusercontent.com/d/15iZ5z3tBMvwaAtpjOoQiSchriAc6l22i"
  },
  {
    "id": "116",
    "name": "Rohit Kumar",
    "designation": "Co-Lead",
    "team": "Technical Team",
    "email": "rohit983527@gmail.com",
    "phone": "9835279029",
    "linkedin": "https://www.linkedin.com/in/rohit-kumar-238b26316/",
    "instagram": "https://www.instagram.com/_rohit__kumar_98/",
    "branch": "CSE (Core)",
    "year": "3rd year",
    "regNo": "24E111B55",
    "dob": "3/18/2006",
    "photo": "https://lh3.googleusercontent.com/d/1zx-4F844SyChJ3u-gm84s1gi6oLjVSuy"
  },
  {
    "id": "117",
    "name": "Ayush Kumar Singh",
    "designation": "Core member",
    "team": "Public Relation Team",
    "email": "s14ayush@gmail.com",
    "phone": "9508904992",
    "linkedin": "https://www.linkedin.com/in/theayush17",
    "instagram": "https://www.instagram.com/theayush_17",
    "branch": "CSE",
    "year": "4th year",
    "regNo": "2341019478",
    "dob": "2/17/2005",
    "photo": "https://lh3.googleusercontent.com/d/1oAPmCI7TPsBmv4QkLLEAXOcoN-o5xb8h"
  },
  {
    "id": "118",
    "name": "Rishit Swain",
    "designation": "Core member",
    "team": "Public Relation Team",
    "email": "rajashreeswain471@gmail.com",
    "phone": "7735776647",
    "linkedin": "https://www.linkedin.com/in/rishit-swain-252768376?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "NA",
    "branch": "CSE(CYSC)",
    "year": "3rd year",
    "regNo": "24E119F02",
    "dob": "9/1/2006",
    "photo": "https://lh3.googleusercontent.com/d/1asVVTc3YREIDdIW5tJBlv1YNMaGAIaNy"
  },
  {
    "id": "119",
    "name": "Shruti Mohanty",
    "designation": "Core member",
    "team": "Event Management Team",
    "email": "shrutimohanty911@gmail.com",
    "phone": "7848094794",
    "linkedin": "https://www.linkedin.com/in/shruti-mohanty-44418b3a3?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "https://www.instagram.com/itsshruti_06?stkn=MWo2aXU5ODJjZzRhaw==",
    "branch": "Btech CSE",
    "year": "3rd year",
    "regNo": "24E113B87",
    "dob": "8/6/2006",
    "photo": "https://lh3.googleusercontent.com/d/1bfVHk4mGquvKMGqeXgn1P3b5cxbuI4uF"
  },
  {
    "id": "120",
    "name": "Sunetra Pandey",
    "designation": "Core member",
    "team": "Technical Team",
    "email": "pandeysunetra7@gmail.com",
    "phone": "24E116B00",
    "linkedin": "https://www.linkedin.com/in/sunetra-pandey-500278323/",
    "instagram": "https://www.instagram.com/__.sunetra/",
    "branch": "CSE (CYSC)",
    "year": "3rd year",
    "regNo": "24E116B00",
    "dob": "2/3/2006",
    "photo": "https://lh3.googleusercontent.com/d/16JyZeP38fbIXoKFyOJelC2lHYVbmda-F"
  },
  {
    "id": "121",
    "name": "Shubham Modi",
    "designation": "Core member",
    "team": "Technical Team",
    "email": "shubhammodi2003@gmail.com",
    "phone": "9102266990",
    "linkedin": "www.linkedin.com/in/shubham-modi-203141253",
    "instagram": "https://www.instagram.com/modi_shubham2709/",
    "branch": "CSIT",
    "year": "4th year",
    "regNo": "2341013225",
    "dob": "9/27/2003",
    "photo": "https://lh3.googleusercontent.com/d/1GRHaOdcZapgqe6BW6XZPcehOWUXdYqGf"
  },
  {
    "id": "122",
    "name": "Apurba Mohapatra",
    "designation": "Core member",
    "team": "Public Relation Team",
    "email": "apurbamohapatra0@gmail.com",
    "phone": "8144188834",
    "linkedin": "https://www.linkedin.com/in/apurba-mohapatra-0940b83a0/",
    "instagram": "https://www.instagram.com/whimsygal__/",
    "branch": "CSE-DS",
    "year": "2nd year",
    "regNo": "25E113D22",
    "dob": "4/29/2007",
    "photo": "https://lh3.googleusercontent.com/d/1y0IDAAWNXu1mYmCOJtwrTlqMnFWGKDHm"
  },
  {
    "id": "123",
    "name": "Srijita Maity",
    "designation": "Core member",
    "team": "Public Relation Team",
    "email": "srijitam72@gmail.com",
    "phone": "6200289245",
    "linkedin": "https://www.linkedin.com/in/srijita-maity-08227a384?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "https://www.instagram.com/srijitaah__?stkn=MTYwc3JyNzhlY3pnNA==",
    "branch": "CSE ",
    "year": "2nd year",
    "regNo": "25E113A61",
    "dob": "10/18/2007",
    "photo": "https://lh3.googleusercontent.com/d/1do4hPr5QDw8hayFE8NdYj43MBZ54k_Hu"
  },
  {
    "id": "124",
    "name": "Rounak Singh",
    "designation": "Core member",
    "team": "Event management Team",
    "email": "rounaksinghfamily169@gmail.com",
    "phone": "6206656615",
    "linkedin": "https://www.linkedin.com/in/rounak-singh-a21a61318?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "https://www.instagram.com/rounakk.singhhh?stkn=a3hsYTRwMnl1ZGJ5",
    "branch": "CSE",
    "year": "3rd year",
    "regNo": "24E119D74",
    "dob": "9/16/2007",
    "photo": "https://lh3.googleusercontent.com/d/163LuTUapWTvgK7rG3ntWy9Ry4LsZdBl0"
  },
  {
    "id": "125",
    "name": "Bibhav Patnaik",
    "designation": "Core member",
    "team": "Event management Team",
    "email": "bpatnaik0912@gmail.com",
    "phone": "8260876042",
    "linkedin": "https://www.linkedin.com/in/bibhav-patnaik-7786b2393?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "https://www.instagram.com/12.bpatnaik?stkn=MW5yeHlwbGk3OTA0aw==",
    "branch": "Btech CSE",
    "year": "3rd year",
    "regNo": "24E116B79",
    "dob": "9/30/2006",
    "photo": "https://lh3.googleusercontent.com/d/1fEYNiQFzfa2emFvviPfXi_xzdYBi3ymB"
  },
  {
    "id": "126",
    "name": "Paresh Sahoo",
    "designation": "Core member",
    "team": "Event management Team",
    "email": "pareshsahoo528@gmail.com",
    "phone": "8895154379",
    "linkedin": "https://www.linkedin.com/in/paresh-sahoo-801068310?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "https://www.instagram.com/n0tso.baka?stkn=MXUxODQ0NXA0MzB2eg==",
    "branch": "Cse (cys)",
    "year": "3rd year",
    "regNo": "24E119B56",
    "dob": "8/2/2006",
    "photo": "https://lh3.googleusercontent.com/d/1KU_19a3ZybUv9BgFOY2iVA900atLzLdl"
  },
  {
    "id": "127",
    "name": "Anshu Kumar Saw",
    "designation": "Core member",
    "team": "Event management Team",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "2nd Year",
    "regNo": "25E119D44",
    "dob": "",
    "photo": ""
  },
  {
    "id": "128",
    "name": "Supriti Sneha Behera",
    "designation": "Lead",
    "team": "Social Media",
    "email": "rudranshubehera18@gmail.com",
    "phone": "9692851156",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "129",
    "name": "Chinmayee Patnaik",
    "designation": "Member",
    "team": "E-Cell",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "130",
    "name": "Saloni Kumari",
    "designation": "Member",
    "team": "E-Cell",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "131",
    "name": "Digant Priyadarshi",
    "designation": "Member",
    "team": "E-Cell",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "132",
    "name": "Tanim Aly",
    "designation": "Member",
    "team": "E-Cell",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "133",
    "name": "Jagadjyoti Patra",
    "designation": "Core",
    "team": "Technical, Public relation",
    "email": "omm.jagadjyoti@gmail.com",
    "phone": "9827617480",
    "linkedin": "https://www.linkedin.com/in/jagadjyoti-patra?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
    "instagram": "https://www.instagram.com/talisman_jp?stkn=aWFxeGp1ZnZmbndo&utm_source=qr",
    "branch": "Computer Science and Engineering (Core)",
    "year": "3rd year",
    "regNo": "24E116B85",
    "dob": "1/11/2006",
    "photo": "https://lh3.googleusercontent.com/d/1GIYTlJnJVhx1NcUPHve32y9LhapcTjHJ"
  },
  {
    "id": "134",
    "name": "Rounak Kumar Mahato",
    "designation": "Core",
    "team": "Event management",
    "email": "rounakmahato039@gmail.com",
    "phone": "8102710351",
    "linkedin": "https://www.linkedin.com/in/rounakmahato",
    "instagram": "https://www.instagram.com/rounak__075",
    "branch": "CSE",
    "year": "3rd year",
    "regNo": "24E113A38",
    "dob": "7/15/2006",
    "photo": "https://lh3.googleusercontent.com/d/1mmV5psriKUDjj3gqwOVIAIpzSLtj6g-K"
  },
  {
    "id": "135",
    "name": "M RENUKA",
    "designation": "Core",
    "team": "Event management",
    "email": "mrenukaa56@gmail.com",
    "phone": "7037763782",
    "linkedin": "https://www.linkedin.com/in/m-renuka-005b81373",
    "instagram": "https://www.instagram.com/_8freya8_",
    "branch": "CSE",
    "year": "3rd year",
    "regNo": "24E118A97",
    "dob": "11/15/2004",
    "photo": "https://lh3.googleusercontent.com/d/1nUS6cY4R4DFH8Lkmq04y22R1IuGtpvcX"
  },
  {
    "id": "136",
    "name": "Shaikh Minhazuddin",
    "designation": "Lead",
    "team": "Public relation",
    "email": "alytanim@gmail.com",
    "phone": "7846897686",
    "linkedin": "https://www.linkedin.com/in/shaikh-minhazuddin-b1b904348",
    "instagram": "https://www.instagram.com/_.tanimm._?stkn=aWZqeGtmaTJ3eHp5",
    "branch": "CSIT",
    "year": "4th year",
    "regNo": "2341013128",
    "dob": "4/5/2005",
    "photo": "https://lh3.googleusercontent.com/d/1rFrvWy-PqiPQFU2V5tBSuVE4jMrx0mqH"
  },
  {
    "id": "137",
    "name": "Sarthak Ranjan Panda",
    "designation": "Core",
    "team": "Public relation",
    "email": "pandasarthak81@gmail.com",
    "phone": "7682986344",
    "linkedin": "https://www.linkedin.com/in/sarthakpanda-/",
    "instagram": "https://www.instagram.com/sarthakpanda17/?hl=en",
    "branch": "CSE",
    "year": "3rd year",
    "regNo": "24E116A76",
    "dob": "6/10/2006",
    "photo": "https://lh3.googleusercontent.com/d/1RckBJU3YzbALfW809SmGH8ZIoH8gQWD7"
  },
  {
    "id": "138",
    "name": "Anuj Kumar Ghadia",
    "designation": "Core",
    "team": "Public relation",
    "email": "anujghadia57@gmail.com",
    "phone": "9937486720",
    "linkedin": "https://www.linkedin.com/in/anuj-kumar-ghadia-b882ba374?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "https://www.instagram.com/sailor._.69?stkn=MTlmaGV5Z2ppN2hrZw==",
    "branch": "Cse",
    "year": "3rd year",
    "regNo": "24E107A18",
    "dob": "9/2/2006",
    "photo": "https://lh3.googleusercontent.com/d/10rUi6ktQlENG9it5jEXem46T1WG_Ytpi"
  },
  {
    "id": "139",
    "name": "Shweta Singh",
    "designation": "Member",
    "team": "E-Cell",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "140",
    "name": "Shubakanta",
    "designation": "Member",
    "team": "E-Cell",
    "email": "",
    "phone": "",
    "linkedin": "",
    "instagram": "",
    "branch": "—",
    "year": "",
    "regNo": "—",
    "dob": "",
    "photo": ""
  },
  {
    "id": "141",
    "name": "AAFRIN TUBA",
    "designation": "Core",
    "team": "Content",
    "email": "per2004sonal@gmail.com",
    "phone": "7205582277",
    "linkedin": "https://www.linkedin.com/in/aafrin-tuba-59951a353?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "instagram": "nirtidaltime",
    "branch": "CSE(core)",
    "year": "3rd year",
    "regNo": "24E120A34",
    "dob": "2/10/2006",
    "photo": "https://lh3.googleusercontent.com/d/1vr6HJ7WGyyoGvLNrkD4DfXFVInv3Q12W"
  }
];
